import { Link } from "react-router";
import ImageWithBasePath from "../../../../components/image-with-base-path";
import { all_routes } from "../../../../routes/all_routes";
import HeaderNav from "../../../../components/header/headerNav";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../../../core/redux/store";
import { setMobileSidebar } from "../../../../core/redux/sidebarSlice";
import Offcanvas from "./offcanvas";


const HeaderSection = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();
 


  const menuOpened = useSelector((state: RootState) => {
    const s = state.sidebar as any;
    // try known/possible property names, fallback to false
    return (s.menuOpened ?? s.mobileSidebar ?? s.isOpen ?? false) as boolean;
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (menuOpened) document.body.classList.add("menu-opned");
    else document.body.classList.remove("menu-opned");
  }, [menuOpened]);

  const onMobileBtn = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(!menuOpened));
  };

  const onMenuClose = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(false));
  };
  // ...existing code...
  return (
    <>
      {/* Header */}
      <header
        className={`header header-fourteen home-menu ${isScrolled ? "fixed" : ""}`}
      >
        <div className="container">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={onMobileBtn}>
                <i className="fa-solid fa-bars" />
              </Link>
              <Link to={all_routes.home} className="navbar-brand logo">
                <ImageWithBasePath
                  src="assets/img/logo-white-14.svg"
                  className="img-fluid white-logo"
                  alt="Logo"
                />
                <ImageWithBasePath
                  src="assets/img/logo-14.svg"
                  className="img-fluid normal-logo"
                  alt="Logo"
                />
              </Link>
            </div>
            <div className="main-menu-wrapper">
              <div className="menu-header">
                <Link to={all_routes.home} className="menu-logo">
                  <ImageWithBasePath
                    src="assets/img/logo-14.svg"
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
                <button
                  type="button"
                  id="menu_close"
                  className="menu-close"
                  aria-label="close"
                  onClick={onMenuClose}
                >
                  <i className="fas fa-times" />
                </button>
              </div>
             <HeaderNav/>
              <div className="header-items">
                {/* Item 1 */}
                <div className="about-popup-item border-0 pb-0">
                  <h3 className="title">Contact Information</h3>
                  <div className="support-item mb-3">
                    <div className="avatar avatar-lg bg-primary rounded-circle">
                      <i className="isax isax-messages-3" />
                    </div>
                    <div>
                      <p className="title">General Inquiries</p>
                      <h4 className="link">info@example.com</h4>
                    </div>
                  </div>
                  <div className="support-item">
                    <div className="avatar avatar-lg bg-primary rounded-circle">
                      <i className="isax isax-call-calling" />
                    </div>
                    <div>
                      <p className="title">Emergency Cases</p>
                      <h4 className="link">+1 24565 89856</h4>
                    </div>
                  </div>
                </div>
                {/* Item 2 */}
                <div className="about-popup-item border-0 pb-0">
                  <h3 className="title">Follow Us</h3>
                  <ul className="d-flex align-items-center gap-2 social-iyem">
                    <li>
                      <Link to="#" className="social-icon" aria-label="facebook">
                        <i className="fa-brands fa-facebook" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="social-icon" aria-label="twitter">
                        <i className="fa-brands fa-x-twitter" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="social-icon"
                        aria-label="instagram"
                      >
                        <i className="fa-brands fa-instagram" />
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="social-icon" aria-label="linkedin">
                        <i className="fa-brands fa-linkedin" />
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="header-items-button">
                  <Link to={all_routes.login} className="btn btn-primary">
                    <i className="isax isax-lock-1 me-2" />
                    Sign In
                  </Link>
                  <Link to={all_routes.register} className="btn btn-secondary">
                    <i className="isax isax-user-tick4 me-2" />
                    Sign Up
                  </Link>
                </div>
              </div>
            </div>
            <ul className="nav header-navbar-rht">
              <li>
                <Link
                  to={all_routes.booking}
                  className="btn btn-secondary theme-14-btn"
                >
                  <i className="isax isax-calendar-tick5" />
                  <span>Book Appointment</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="details-btn"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#support_item"
                  aria-label="about"
                >
                  <i className="isax isax-menu" />
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      {/* Header End */}
      <Offcanvas/>
    </>
  );
};

export default HeaderSection;
